/**
 * @fileoverview This file is more like a utility file, it's not a hook.
 * We can switch over endpoint base url by comment. Used to switch in
 * development context / deployed version.
 */

export const ENDPOINT_URL =
  "https://unitask-backend-impl-72c59f313288.herokuapp.com/";

// export const ENDPOINT_URL = "http://localhost:8080/";
